import React from 'react'

const Question = (props) => (
  <div className='mb4'>
    <div className='mb3'>
      {props.question}
    </div>
    <div>
      {props.answer}
    </div>
  </div>
)

export default Question



// WEBPACK FOOTER //
// ./src/routes/FaQs/Question.js